declare const jQuery: any;
const $ = jQuery;

import { initLogoGrid } from './logo-grid';
import { initMainBanner } from './main-banner';
import { initLangSelector } from './language-selector';
import { initGradientContent } from './gradient-content';
import { initContactForms } from './contact-forms';
import { initFiniteSliders } from './finite-slider';
import { initMultiContentSliders } from './multi-content-slider';
import { initVideoSliders } from './video-slider';

const initCustomSelect: Function = window['iw'].initCustomSelect;
const keepInProportionUsingAttrs: Function = window["iw"].layout.keepInProportionUsingAttrs;

initLogoGrid();
initMainBanner();
initLangSelector();
initGradientContent();
initContactForms();
initFiniteSliders();
initMultiContentSliders();
initVideoSliders();

// fix display grid on PoS browsers (ie)
$(($) => {
    const supportsGrid: boolean =
        typeof document.createElement('div').style.grid === 'string';
    if (supportsGrid) {
        return;
    }
    $('.tile-links > div').each(function () {
        const $div = $(this);
        $div.css({
            display: 'flex',
            'flex-wrap': 'wrap',
        });
        $div.find('.tile-link').css({
            width: '50%',
        });
    });
    $('.logo-grid > div').each(function () {
        const $div = $(this);
        $div.css({
            display: 'flex',
            'flex-wrap': 'wrap',
        });
        $div.find('.logo-grid-item').css({
            width: '25%',
        });
    });
    $('.multi-column-main-footer .main-footer-middle-row > div').css({
        display: 'block',
    });
    $('.main-footer-column').css({
        textAlign: 'center',
    });
});

// cf7 - custom <select>
$(($) => {
    $('.wpcf7-form select').each(function () {
        const $select = $(this);
        $select.find('option').first().val('');
        $select.attr('data-no-null', '');
        initCustomSelect($select);
        $select.css({ display: 'none' });
    });

    // CF7 - ajax loader
    $('.wpcf7-form .ajax-loader').before(`<br />`);
});

$('.two-column-row').each(function () {
    const $wrap = $(this);
    keepInProportionUsingAttrs($wrap.find('.col-multi').find('iframe,video'));
});
